import { render, staticRenderFns } from "./ExerciseTest.vue?vue&type=template&id=9fe5971a&scoped=true"
import script from "./ExerciseTest.vue?vue&type=script&lang=js"
export * from "./ExerciseTest.vue?vue&type=script&lang=js"
import style0 from "./ExerciseTest.vue?vue&type=style&index=0&id=9fe5971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe5971a",
  null
  
)

export default component.exports